import { Alert as BootstrapAlert } from "react-bootstrap";

/**
 * Accessible visual and screen-reader status message.
 *
 * Alerts are visible and announced by default:
 * - `hidden`: announce through the permanently mounted hidden status.
 * - `announce={false}`: show the Bootstrap alert without announcing it.
 * - Default: the visible alert uses `role="alert"` and provides the
 *   announcement; the hidden status is cleared to prevent duplicate speech
 *   and duplicate hidden links or controls.
 * - `hidden announce={false}`: render only the empty live region so it remains
 *   mounted for a later announcement.
 *
 * WCAG 2.2, 4.1.3 Status Messages:
 * https://www.w3.org/WAI/WCAG22/Understanding/status-messages.html
 * WAI-ARIA Alert Pattern:
 * https://www.w3.org/WAI/ARIA/apg/patterns/alert/
 */
export default function Alert({
  announce = true,
  hidden = false,
  children,
  ...props
}) {
  let audioMessage = "";
  let visualRole = "presentation";
  let visualComponent = "";

  if (announce) {
    audioMessage = children;
    visualRole = "alert";
  }

  if (!hidden) {
    audioMessage = "";
    visualComponent = (
      <BootstrapAlert
        {...props}
        role={visualRole}
        transition={false}
      >
        {children}
      </BootstrapAlert>
    );
  }

  return (
    <>
      <span
        className="visually-hidden"
        role="status"
        aria-live="polite"
        aria-atomic="true"
      >
        {audioMessage}
      </span>
      {visualComponent}
    </>
  );
}
